const LoadingIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            d="M7.296 13.306A6.668 6.668 0 0 1 .03 6.04C.303 3.086 2.596.626 5.516.106a6.386 6.386 0 0 1 2.693.08c.387.094.6.507.467.874a.66.66 0 0 1-.773.42 5.358 5.358 0 0 0-1.74-.127c-2.694.247-4.834 2.593-4.84 5.3a5.34 5.34 0 0 0 6.08 5.293c2.466-.34 4.413-2.44 4.573-4.926a5.185 5.185 0 0 0-.133-1.587.665.665 0 0 1 .426-.773c.374-.134.78.08.874.46a6.391 6.391 0 0 1-.247 3.853c-.9 2.373-3.08 4.1-5.6 4.333Z"
            clipRule="evenodd"
        />
    </svg>
);

export default LoadingIcon;
